import React from "react";
import {
  Grid,
  Typography,
  Divider,
  Popover,
  MenuItem,
  Select,
  OutlinedInput,
  InputLabel,
  FormControl,
  IconButton,
  ListItemIcon,
  Checkbox,
  ListItemSecondaryAction,
  ListItem,
} from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import ClearIcon from "@mui/icons-material/Clear";
import CheckIcon from "@mui/icons-material/Check";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

import PrimaryButton from "../PrimaryButton";
import CustomIcon from "../CustomIcon";
import settingsIcon from "../../../assets/icons/settings.svg";
import printerIcon from "../../../assets/icons/printer.svg";
import mailIcon from "../../../assets/icons/mail.svg";
import LinkButton from "../LinkButton";
import TableCustomization from "./TableCustomization";
import LoopIcon from "@mui/icons-material/Loop";
import BlockIcon from "@mui/icons-material/Block";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import DeleteIcon from "@mui/icons-material/Delete";
import SortIcon from "@mui/icons-material/Sort";

const TableHeader = ({
  reportHeader,
  defaultColumns,
  allColumns,
  inUseColumns,
  numberOfRows,
  numberOfSelectedRows,
  handlePrint,
  handleMail,
  handleViewMessages,
  handleReGenerateAlert,
  handleActivateCustomers,
  handleRemoveCustomers,
  handleIsAssginOpen,
  handleUnselectAll,
  handleColumnsChange,
  anchorEl,
  setAnchorEl,
  customizationRef,
  setCurrentGroupBy,
  currentGroupBy = [],
  currentOrderBy = [],
  setCurrentOrderBy,
  isPrint = true,
  isMail = true,
  isView = true,
  isHistory = true,
  isReGenerate = false,
  isDeactive = false,
  isActive = false,
  isAssgin = false,
  isRemove = false,
  showGroupBy = false,
  setColumns,
  columnsOrderDirection = {},
  setColumnsOrderDirection,
}) => {
  const handleOpenCustomization = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleCloseCustomization = (e) => {
    setAnchorEl(null);
  };

  const handleSaveCustomization = (inUseItems) => {
    // if (showGroupBy && setCurrentGroupBy) setCurrentGroupBy(currentGroupBy);
    // if (showGroupBy && setCurrentOrderBy) setCurrentOrderBy(currentOrderBy);
    handleColumnsChange(inUseItems);
    setAnchorEl(null);
  };

  const handleCancelCustomization = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "customize-table-columns" : undefined;

  React.useEffect(() => {
    if (setCurrentGroupBy) setCurrentGroupBy(currentGroupBy);
    if (setCurrentOrderBy) setCurrentOrderBy(currentOrderBy);
  }, [
    currentGroupBy,
    setCurrentGroupBy,
    setCurrentOrderBy,
    currentOrderBy,
    open,
  ]);

  return (
    <>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid item>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <Typography
                sx={{ color: "#50566E", fontSize: 15, fontWeight: "bold" }}
              >
                {numberOfSelectedRows <= 0
                  ? `${numberOfRows} items`
                  : `${numberOfSelectedRows} selected`}
              </Typography>
            </Grid>
            {numberOfSelectedRows > 0 && (
              <>
                <Grid item>
                  <Divider
                    orientation="vertical"
                    sx={{
                      height: 30,
                      borderRight: "1px solid var(--secondary)",
                    }}
                  />
                </Grid>
                {isPrint && (
                  <Grid item>
                    <PrimaryButton
                      onClick={handlePrint}
                      tooltip="Print"
                      isIconButton
                    >
                      <CustomIcon
                        svgIcon={printerIcon}
                        sx={{ color: "var(--secondary)" }}
                        fontSize="small"
                      />
                    </PrimaryButton>
                  </Grid>
                )}
                {isMail && (
                  <Grid item>
                    <PrimaryButton
                      onClick={handleMail}
                      ref={customizationRef}
                      tooltip="Mail"
                      isIconButton
                    >
                      <CustomIcon svgIcon={mailIcon} fontSize="small" />
                    </PrimaryButton>
                  </Grid>
                )}
                {isView && (
                  <Grid item>
                    <PrimaryButton
                      onClick={handleViewMessages}
                      tooltip="View"
                      isIconButton
                    >
                      <RemoveRedEyeIcon fontSize="small" />
                    </PrimaryButton>
                  </Grid>
                )}
                {isHistory && (
                  <Grid item>
                    <PrimaryButton tooltip="History" isIconButton>
                      <HistoryIcon fontSize="small" />
                    </PrimaryButton>
                  </Grid>
                )}
                {isReGenerate && (
                  <Grid item>
                    <PrimaryButton
                      tooltip="ReGenerate"
                      isIconButton
                      onClick={handleReGenerateAlert}
                    >
                      <LoopIcon fontSize="small" />
                    </PrimaryButton>
                  </Grid>
                )}
                {isDeactive && (
                  <Grid item>
                    <PrimaryButton
                      tooltip="Deactivate"
                      isIconButton
                      onClick={() =>
                        handleActivateCustomers({
                          status: true,
                          Type: "INACTIVE",
                        })
                      }
                    >
                      <BlockIcon fontSize="small" />
                    </PrimaryButton>
                  </Grid>
                )}
                {isActive && (
                  <Grid item>
                    <PrimaryButton
                      tooltip="Activate"
                      isIconButton
                      onClick={() =>
                        handleActivateCustomers({
                          status: true,
                          Type: "ACTIVE",
                        })
                      }
                    >
                      <RadioButtonUncheckedIcon fontSize="small" />
                    </PrimaryButton>
                  </Grid>
                )}
                {isRemove && (
                  <Grid item>
                    <PrimaryButton
                      tooltip="Remove"
                      isIconButton
                      onClick={() => handleRemoveCustomers()}
                    >
                      <DeleteIcon fontSize="small" />
                    </PrimaryButton>
                  </Grid>
                )}
                {isAssgin && (
                  <Grid item>
                    <PrimaryButton
                      tooltip="Assgin Customers"
                      isIconButton
                      onClick={handleIsAssginOpen}
                    >
                      <GroupAddIcon fontSize="small" />
                    </PrimaryButton>
                  </Grid>
                )}
                <Grid item>
                  <LinkButton
                    onClick={handleUnselectAll}
                    sx={{ color: "var(--secondary)" }}
                  >
                    Unselect All
                  </LinkButton>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
        <Grid item>
          <PrimaryButton
            onClick={handleOpenCustomization}
            isIconButton
            tooltip="Customize"
          >
            <CustomIcon svgIcon={settingsIcon} fontSize="small" />
          </PrimaryButton>
        </Grid>
      </Grid>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleCloseCustomization}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        key={open}
      >
        {showGroupBy && (
          <>
            <div
              style={{
                paddingTop: "1rem",
                paddingRight: "0.5rem",
                paddingLeft: "0.5rem",
                width: "100%",
              }}
            >
              <FormControl fullWidth>
                <InputLabel id="groupByLabel">Group By</InputLabel>
                <Select
                  labelId="groupByLabel"
                  label="Groups"
                  fullWidth
                  value={currentGroupBy}
                  onChange={(e) =>
                    setCurrentGroupBy(
                      typeof e.target.value === "string"
                        ? e.target.value.split(",")
                        : e.target.value
                    )
                  }
                  renderValue={(selected) =>
                    selected
                      .map((val) => val.charAt(0).toUpperCase() + val.slice(1))
                      .join(", ")
                  }
                  sx={{ textTransform: "capitalize" }}
                  input={<OutlinedInput label="Name" />}
                  endAdornment={
                    <IconButton
                      sx={{ marginRight: "1rem", marginLeft: "1rem" }}
                      onClick={() => setCurrentGroupBy([])}
                    >
                      <ClearIcon />
                    </IconButton>
                  }
                  multiple
                >
                  {allColumns
                    ?.filter((col) => col.key !== "transactionId")
                    .map((column, index) => (
                      <MenuItem
                        key={index}
                        value={column.key}
                        sx={{ textTransform: "capitalize" }}
                      >
                        {currentGroupBy.includes(column.key) && (
                          <ListItemIcon>
                            <CheckIcon fontSize="small" />
                          </ListItemIcon>
                        )}
                        {column.title}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>
            <div
              style={{
                paddingTop: "1rem",
                paddingRight: "0.5rem",
                paddingLeft: "0.5rem",
                width: "100%",
              }}
            >
              <FormControl fullWidth>
                <InputLabel id="orderByLabel">Order By</InputLabel>
                <Select
                  labelId="orderByLabel"
                  label="Order"
                  fullWidth
                  value={currentOrderBy}
                  onChange={(e) => {
                    setCurrentOrderBy(
                      typeof e.target.value === "string"
                        ? e.target.value.split(",")
                        : e.target.value
                    );
                  }}
                  renderValue={(selected) =>
                    selected
                      .map((val) => val.charAt(0).toUpperCase() + val.slice(1))
                      .join(", ")
                  }
                  sx={{ textTransform: "capitalize" }}
                  input={<OutlinedInput label="Name" />}
                  endAdornment={
                    <IconButton
                      sx={{ marginRight: "1rem", marginLeft: "1rem" }}
                      onClick={() => setCurrentOrderBy([])}
                    >
                      <ClearIcon />
                    </IconButton>
                  }
                  multiple
                >
                  {allColumns
                    ?.filter((col) => col.key !== "transactionId")
                    .map((column) => {
                      const value = column.key;
                      const isSelected = currentOrderBy.includes(value);

                      return (
                        <MenuItem
                          key={`${value}_${columnsOrderDirection[value]}`}
                          value={value}
                          sx={{ textTransform: "capitalize" }}
                        >
                          <ListItem
                            {...(isSelected && {
                              secondaryAction: (
                                <Checkbox
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                  checked={columnsOrderDirection[value]}
                                  onChange={(e) => {
                                    // columnsOrderDirection[value] = checked;
                                    setColumnsOrderDirection({
                                      ...columnsOrderDirection,
                                      [value]: e.target.checked,
                                    });
                                  }}
                                  size="small"
                                  checkedIcon={<SortIcon fontSize="small" />}
                                  icon={
                                    <SortIcon
                                      fontSize="small"
                                      sx={{
                                        transform: "rotateX(180deg)",
                                      }}
                                    />
                                  }
                                />
                              ),
                            })}
                          >
                            {column.title}
                          </ListItem>
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </div>
          </>
        )}

        <TableCustomization
          reportHeader={reportHeader}
          allItems={allColumns}
          inUseItems={inUseColumns}
          defaultItems={defaultColumns}
          setColumnsOnChange={setColumns}
          handleSaveCustomization={handleSaveCustomization}
          handleCancelCustomization={handleCancelCustomization}
        />
      </Popover>
    </>
  );
};

export default TableHeader;
